import { Alert } from 'antd';
import { observer } from 'mobx-react';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import TextLoop from 'react-text-loop';
import HashLink from 'components/HashLink';
import APP from 'stores/APP';
import security from 'stores/security';
import { AlertItemProps, MessageType, notifyConfig } from './config';
import './style.scss';

function getHrefByType(msgType: MessageType): string {
    switch (msgType) {
        case 'password':
            return '/profile/security/set/password';
        default:
            // eslint-disable-next-line
            const checkNever: never = msgType;

            return '';
    }
}

const AlertMessage: React.FC<{ list: AlertItemProps[] }> = ({ list }) => {
    const navigate = useNavigate();
    const renderChildren = useMemo(() => {
        return list.map((item: AlertItemProps) => {
            const { content, btnText, href, internal, type, restContent } = item;

            return (
                <div key={type}>
                    {content}
                    <HashLink className="notify-btn" onClick={() => (internal ? navigate(href) : APP.updateHref(href))}>
                        {btnText}
                    </HashLink>
                    {restContent}
                </div>
            );
        });
    }, [list, navigate]);

    // TextLoop并不能随着children的变化实时更新, 所以这里根据List计算一个变化的key, 达到TextLoop实时更新的效果
    const textLoopKey = useMemo(() => list.map(item => item.type).join(''), [list]);

    return (
        <TextLoop
            key={textLoopKey}
            className="notify-text-loop"
            mask
            noWrap={false}
            interval={10000}
            children={renderChildren}
        />
    );
};

const Notify: React.FC = observer(() => {
    const { userInfo: { loginPassword } = {} } = security;
    const alertList = useMemo<AlertItemProps[]>(() => {
        const list: AlertItemProps[] = [];

        // 没有密码、提示去设置密码(目前只有这一种类型通知)
        if (!loginPassword) {
            list.push({
                ...notifyConfig.password,
                href: getHrefByType('password')
            });
        }

        return list;
    }, [loginPassword]);

    return alertList.length ? (
        <Alert className="notify-root" banner message={<AlertMessage list={alertList} />} />
    ) : null;
});

export default Notify;
